import Vue from 'vue';
import Vuex from 'vuex';

import { IBreadCrumbsState } from './modules/breadCrumbs';
import { IProfileState } from '@/store/modules/auth';
import { IRegionState } from '@/store/modules/region';
import { IMapState } from '@/store/modules/map';
import { IServicesState } from '@/store/modules/services';
import { IErrorAlertState } from '@/store/modules/errors';
import { IIdentityDocumentsState } from '@/store/modules/identityDocuments';
import { INotificationState } from '@/store/modules/notifications';
import { INotificationDocState } from '@/store/modules/notificationsDocuments';
import { ICountriesState } from '@/store/modules/countries';
import { IStatementStatusInfoState } from '@/store/modules/statementStatusInfo';
import { IStatementInfoToShowState } from '@/store/modules/statementInfoToShow';
import { ILanguagesState } from '@/store/modules/languages';
import { IStatementJointState } from '@/store/modules/statementsJoint';

Vue.use(Vuex);

export interface IRootState {
  breadCrumbs: IBreadCrumbsState;
  auth: IProfileState;
  region: IRegionState;
  map: IMapState;
  services: IServicesState;
  errors: IErrorAlertState;
  identityDocuments: IIdentityDocumentsState;
  notifications: INotificationState;
  notificationDoc: INotificationDocState;
  countries: ICountriesState;
  statementStatusInfo: IStatementStatusInfoState;
  statementInfoToShow: IStatementInfoToShowState;
  languages: ILanguagesState;
  statementsJoint: IStatementJointState;
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({});
